/* Nova — card swatches, quick-add popup, mobile hero video, collection SEO toggle. */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var strings = window.novaStrings || {};
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Card swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.nova-swatch');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.card-wrapper');
    if (!card) return;

    card.querySelectorAll('.nova-swatch.is-active').forEach(function (b) { b.classList.remove('is-active'); });
    sw.classList.add('is-active');

    var name = card.querySelector('[data-nova-color-name]');
    if (name) name.textContent = sw.dataset.color;

    var img = card.querySelector('.card__media img');
    if (img && sw.dataset.src) {
      img.srcset = sw.dataset.srcset || '';
      img.src = sw.dataset.src;
    }
    if (sw.dataset.url) {
      card.querySelectorAll('a.full-unstyled-link').forEach(function (a) { a.href = sw.dataset.url; });
    }
    var qa = card.querySelector('[data-nova-quick-add]');
    if (qa && sw.dataset.variantId) qa.dataset.variantId = sw.dataset.variantId;
  });

  /* ---------- Quick-add popup ---------- */
  var dialog = null;
  var state = null;

  function getDialog() {
    if (!dialog) {
      dialog = document.getElementById('NovaQuickAdd');
      if (!dialog) return null;
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-nova-qa-close]')) dialog.close();
      });
    }
    return dialog;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=nova-quick')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        cache[handle] = data;
        return data;
      });
  }

  // "41mm (Series 7-9)" and "Apple Watch Series 11 & 10 - 42mm" both -> "41mm" / "42mm"
  function mmOf(value) {
    var m = /(\d{2})\s*mm/i.exec(value || '');
    return m ? m[1] + 'mm' : null;
  }

  // Size label the shopper already picked on the product page (e.g. "Apple Watch Series 10-12 - 42mm"),
  // used to pre-select the size of an upsell / bundle product.
  function sizeFromPage() {
    var picker = document.querySelector('product-info variant-selects, variant-selects');
    if (!picker) return null;
    var values = [];
    picker.querySelectorAll('select').forEach(function (s) { values.push(s.value); });
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (i) { values.push(i.value); });
    for (var i = 0; i < values.length; i++) {
      if (mmOf(values[i])) return values[i];
    }
    return null;
  }

  // Watch sizes mentioned in a label: "Series 1-9 & SE - 38/40/41mm" -> [38, 40, 41], "Series 7-9 (41MM)" -> [41]
  function sizesIn(label) {
    var out = [], re = /(\d{2})(?=\s*(?:\/|mm))/gi, m;
    while ((m = re.exec(label || ''))) out.push(m[1]);
    return out;
  }
  // Watch generation, to tell "Series 1-3 (42MM)" from "Series 10 & 11 (42MM)"
  function generationOf(label) {
    if (/ultra/i.test(label)) return 'ultra';
    if (/\b1[0-2]\b/.test(label)) return 'new';
    return 'old';
  }
  // Best value among `values` for the hint label (straps <-> cases use different wording)
  function pickByHint(values, hint) {
    var hs = sizesIn(hint);
    if (!hs.length) return null;
    var gen = generationOf(hint), last = hs[hs.length - 1], best = null, bestScore = 0;
    values.forEach(function (v) {
      var vs = sizesIn(v);
      var shared = vs.filter(function (n) { return hs.indexOf(n) > -1; }).length;
      if (!shared) return;
      var score = shared * 10 + (generationOf(v) === gen ? 5 : 0) + (vs.indexOf(last) > -1 ? 1 : 0);
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best;
  }

  window.novaPickByHint = pickByHint;
  window.novaSizeFromPage = sizeFromPage;

  function findVariant(selected) {
    return state.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
  }

  function valueAvailable(optIndex, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, i) { return i === optIndex || o === state.selected[i]; });
    });
  }

  function render() {
    var p = state.product;
    var v = findVariant(state.selected);
    var html = '';
    html += '<div class="nova-qa__media"><img src="' + esc((v && v.image) || p.image) + '" alt="' + esc(p.title) + '" width="900" height="900"></div>';
    html += '<div class="nova-qa__info">';
    html += '<h2 class="nova-qa__title" id="NovaQuickAddTitle">' + esc(p.title) + '</h2>';
    html += '<p class="nova-qa__price">' + (v ? esc(v.price) + (v.compare ? ' <s>' + esc(v.compare) + '</s>' : '') : '') + '</p>';

    p.options.forEach(function (opt, oi) {
      if (opt.values.length < 2 && !opt.color) {
        return;
      }
      if (!opt.color) {
        // sizes & other options: dropdown
        var sid = 'NovaQaOpt-' + oi;
        var guide = strings.sizeGuide && /size/i.test(opt.name)
          ? '<button type="button" class="nova-size-guide-link" data-nova-dialog-open="NovaSizeGuideGlobal">' +
            '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.3"/><path d="M10 9v5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="10" cy="6.3" r=".9" fill="currentColor"/></svg>' +
            esc(strings.sizeGuide) + '</button>'
          : '';
        html += '<div class="nova-qa__option nova-qa__option--select"><div class="nova-option-head"><label class="nova-qa__label" for="' + sid + '">' + esc(opt.name) + '</label>' + guide + '</div>';
        html += '<div class="nova-qa__select-wrap"><select id="' + sid + '" class="nova-qa__select" data-opt="' + oi + '">';
        opt.values.forEach(function (val) {
          var avail = valueAvailable(oi, val.name);
          html += '<option value="' + esc(val.name) + '"' + (state.selected[oi] === val.name ? ' selected' : '') + '>' +
            esc(val.name) + (avail ? '' : ' — ' + esc(strings.unavailable)) + '</option>';
        });
        html += '</select><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div></div>';
        return;
      }
      html += '<fieldset class="nova-qa__option nova-qa__option--color">';
      html += '<legend>' + esc(opt.name) + ': <strong>' + esc(state.selected[oi]) + '</strong></legend><div class="nova-qa__values">';
      opt.values.forEach(function (val) {
        var on = state.selected[oi] === val.name;
        var avail = valueAvailable(oi, val.name);
        var cls = 'nova-qa__value nova-swatch-btn' + (on ? ' is-active' : '') + (avail ? '' : ' is-unavailable');
        // product photo of that color when available, color swatch otherwise
        var inner = val.img
          ? '<img class="nova-qa__thumb" src="' + esc(val.img) + '" alt="" width="64" height="64">'
          : '<span class="nova-swatch nova-swatch--static" data-swatch="' + esc(val.handle) + '"></span>';
        html += '<button type="button" class="' + cls + (val.img ? ' has-img' : '') + '" data-opt="' + oi + '" data-val="' + esc(val.name) + '" aria-pressed="' + on + '" title="' + esc(val.name) + '">' +
          inner + '<span class="visually-hidden">' + esc(val.name) + '</span></button>';
      });
      html += '</div></fieldset>';
    });

    var label = !v ? strings.unavailable : v.available ? strings.addToCart + ' – ' + v.price : strings.soldOut;
    html += '<button type="button" class="nova-qa__add button" data-nova-qa-add' + (v && v.available ? '' : ' disabled') + '>' + esc(label) + '</button>';
    html += '<p class="nova-qa__error" role="alert" hidden></p>';
    html += '<a class="nova-qa__details" href="' + esc(p.url) + (v ? '?variant=' + v.id : '') + '">' + esc(strings.viewDetails || 'View full details') + ' →</a>';
    html += '</div>';
    state.body.innerHTML = html;
  }

  function openQuickAdd(btn) {
    if (btn.hasAttribute('data-current-product')) {
      var pageVariant = document.querySelector('product-info [name="id"], .product-form [name="id"]');
      if (pageVariant && pageVariant.value) btn.dataset.variantId = pageVariant.value;
    }
    var dlg = getDialog();
    if (!dlg) return;
    var body = dlg.querySelector('[data-nova-qa-body]');
    btn.classList.add('is-loading');

    fetchProduct(btn.dataset.handle)
      .then(function (product) {
        var start = product.variants.find(function (v) { return String(v.id) === btn.dataset.variantId; }) ||
          product.variants.find(function (v) { return v.available; }) || product.variants[0];
        state = { product: product, selected: start.options.slice(), body: body, opener: btn, bundle: btn.hasAttribute('data-bundle') };

        var hint = btn.dataset.sizeHint ||
          (btn.hasAttribute('data-size-from-page') || btn.hasAttribute('data-bundle') ? sizeFromPage() : null) ||
          (btn.hasAttribute('data-bundle') ? window.novaCartSizeHint : null);
        if (hint) {
          product.options.forEach(function (opt, oi) {
            var match = pickByHint(opt.values.map(function (val) { return val.name; }), hint);
            if (match) state.selected[oi] = match;
          });
          var v = findVariant(state.selected);
          if (!v || !v.available) {
            // keep the size, fall back to any available variant of that size
            var sizeIdx = state.selected.findIndex(function (x) { return /\d\s*mm/i.test(x); });
            var alt = product.variants.find(function (x) { return x.available && (sizeIdx < 0 || x.options[sizeIdx] === state.selected[sizeIdx]); });
            if (alt) state.selected = alt.options.slice();
          }
        }
        render();
        if (!dlg.open) dlg.showModal();
      })
      .catch(function (err) {
        // fallback: open the product page; keep the reason for debugging
        try { sessionStorage.setItem('novaQaError', String((err && err.stack) || err)); } catch (e) {}
        if (window.console) console.error('Nova quick add failed', err);
        window.location.href = root + 'products/' + btn.dataset.handle;
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  function addToCart(btn) {
    var v = findVariant(state.selected);
    if (!v || !v.available) return;
    if (typeof window.novaPick === 'function') {
      // Bundle & Save slot picking: hand the variant back instead of adding it to the cart
      var pick = window.novaPick;
      window.novaPick = null;
      dialog.close();
      pick({ variant: v, product: state.product });
      return;
    }
    var errorEl = state.body.querySelector('.nova-qa__error');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer) {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : root + 'cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          errorEl.textContent = res.json.description || res.json.message || strings.error;
          errorEl.hidden = false;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nova-quick-add', productVariantId: v.id, cartData: res.json });
        }
        dialog.close();
        if (state.bundle && window.novaBundle) {
          // stay in the bundle popup: refresh the drawer silently, update progress
          window.novaBundle.afterAdd(res.json, state.opener);
          return;
        }
        if (drawer && res.json.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
      })
      .catch(function () {
        errorEl.textContent = strings.error;
        errorEl.hidden = false;
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  }

  function selectValue(oi, value) {
    state.selected[oi] = value;
    var v = findVariant(state.selected);
    if (!v || !v.available) {
      // keep the chosen value, fall back to an available combination
      var alt = state.product.variants.find(function (x) { return x.available && x.options[oi] === value; });
      if (alt) state.selected = alt.options.slice();
    }
    render();
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.nova-qa__select');
    if (sel && state) selectValue(Number(sel.dataset.opt), sel.value);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nova-quick-add]');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      openQuickAdd(opener);
      return;
    }
    if (!state || !dialog || !dialog.contains(e.target)) return;

    var valBtn = e.target.closest('.nova-qa__value');
    if (valBtn) {
      selectValue(Number(valBtn.dataset.opt), valBtn.dataset.val);
      return;
    }
    var addBtn = e.target.closest('[data-nova-qa-add]');
    if (addBtn) addToCart(addBtn);
  });

  /* ---------- Mobile "View more" on featured collections ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nova-view-more]');
    if (!btn) return;
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) return;
    var step = parseInt(btn.dataset.novaViewMore, 10) || 8;
    var hidden = list.querySelectorAll('.nova-m-more');
    for (var i = 0; i < Math.min(step, hidden.length); i++) hidden[i].classList.remove('nova-m-more');
    if (hidden.length <= step) {
      // everything is visible: the button becomes the "View all" link to the collection
      var link = document.createElement('a');
      link.className = btn.className;
      link.href = btn.dataset.viewAllUrl || '#';
      link.textContent = btn.dataset.viewAllLabel || 'View all';
      btn.replaceWith(link);
    }
  });

  /* ---------- Hero videos: only download the one matching the screen ---------- */
  function loadVideos() {
    document.querySelectorAll('video[data-nova-video]:not([data-loaded])').forEach(function (video) {
      if (!window.matchMedia(video.dataset.novaVideo).matches) return;
      video.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
      video.setAttribute('data-loaded', '');
      video.load();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---------- Collection SEO "Read more" ---------- */
  function initSeo() {
    document.querySelectorAll('[data-nova-seo].is-collapsible:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '');
      var body = box.querySelector('.nova-seo__body');
      var toggle = box.querySelector('.nova-seo__toggle');
      var limit = parseInt(getComputedStyle(box).getPropertyValue('--seo-collapsed'), 10) || 220;
      if (body.scrollHeight <= limit + 40) {
        box.classList.remove('is-collapsible');
        toggle.remove();
        return;
      }
      toggle.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
        toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
      });
    });
  }

  function init() {
    loadVideos();
    initSeo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.matchMedia('(max-width: 749px)').addEventListener('change', loadVideos);
  document.addEventListener('shopify:section:load', init);
})();

/* Nova — sticky add-to-cart bar on product pages. */
if (!customElements.get('nova-sticky-atc')) {
  customElements.define(
    'nova-sticky-atc',
    class NovaStickyAtc extends HTMLElement {
      connectedCallback() {
        // escape the sticky info column so position: fixed is relative to the viewport;
        // moving the element re-runs connectedCallback, so move once and set up only once (no infinite loop)
        if (this.parentElement !== document.body) { document.body.appendChild(this); return; }
        if (this._ready) return;
        this.btn = this.querySelector('button');
        this.mainBtn = document.querySelector('#' + this.dataset.form + ' [name="add"]');
        if (!this.mainBtn || !this.btn) return;
        this._ready = true;
        // bundle option selected -> scroll to the Bundle & Save widget; otherwise (single strap, cases) add to cart directly
        this.btn.addEventListener('click', () => {
          const offer = document.querySelector('nova-bundle-offer');
          if (!offer || offer.mode !== 'bundle') {
            this.mainBtn.click();
            return;
          }
          const target = offer;
          const header = document.querySelector('.section-header');
          const offset = (header ? header.getBoundingClientRect().height : 0) + 16;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
          // fallback if smooth scrolling didn't run (reduced motion, background tab…)
          setTimeout(() => { if (Math.abs(window.scrollY - top) > 40) window.scrollTo(0, top); }, 700);
          target.classList.remove('nova-flash');
          void target.offsetWidth;
          target.classList.add('nova-flash');
        });

        // visible once the main button has scrolled above the viewport
        const update = () => this.classList.toggle('is-visible', this.mainBtn.getBoundingClientRect().bottom < 0);
        window.addEventListener('scroll', update, { passive: true });
        update();

        this.sync();
        new MutationObserver(() => this.sync()).observe(this.mainBtn, { attributes: true, childList: true, subtree: true });
        const price = document.getElementById(this.dataset.price);
        if (price) new MutationObserver(() => this.sync()).observe(price, { childList: true, subtree: true, characterData: true });
      }

      sync() {
        const price = document.getElementById(this.dataset.price);
        const current = price && (price.querySelector('.price-item--sale') || price.querySelector('.price-item--regular'));
        const amount = current ? current.textContent.trim() : '';
        const disabled = this.mainBtn.disabled || this.mainBtn.getAttribute('aria-disabled') === 'true';
        this.btn.disabled = disabled;
        this.btn.textContent = disabled ? this.mainBtn.textContent.trim() : this.dataset.label + (amount ? ' – ' + amount : '');
      }
    }
  );
}

/* Nova — dots under the mobile product gallery. */
(function () {
  function initDots() {
    document.querySelectorAll('media-gallery slider-component[id^="GalleryViewer"]:not([data-nova-dots])').forEach(function (viewer) {
      var list = viewer.querySelector('.product__media-list');
      var slides = list ? Array.prototype.filter.call(list.children, function (li) { return li.offsetParent !== null || li.classList.contains('product__media-item'); }) : [];
      if (slides.length < 2) return;
      viewer.setAttribute('data-nova-dots', '');
      var dots = document.createElement('div');
      dots.className = 'nova-gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dots.appendChild(d);
      });
      viewer.after(dots);
      list.addEventListener('scroll', function () {
        var i = Math.round(list.scrollLeft / list.clientWidth);
        Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDots);
  else initDots();
})();

/* Nova — generic dialogs (size guide). */
document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-nova-dialog-open]');
  if (opener) {
    var dlg = document.getElementById(opener.dataset.novaDialogOpen);
    if (dlg && dlg.showModal) {
      if (dlg.parentElement !== document.body) document.body.appendChild(dlg); // escape transformed/sticky parents
      dlg.showModal();
    }
    return;
  }
  var dialog = e.target.closest('dialog.nova-dialog');
  if (dialog && (e.target === dialog || e.target.closest('[data-nova-dialog-close]'))) dialog.close();
});

/* Nova — Buy X get Y: live progress bars + bundle builder popup. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function renderBars(count) {
    var c = window.novaBxgy;
    if (!c) return;
    var buy = c.buy, get = c.get, group = buy + get;
    var rem = count % group;
    var free = Math.floor(count / group) * get;
    var msg, pct, filled;
    if (count === 0) { msg = c.msgEmpty; pct = 0; }
    else if (rem === 0) { msg = c.msgUnlocked; pct = 100; }
    else if (rem >= buy) { msg = c.msgNextFree; pct = Math.floor((rem * 100) / group); }
    else if (free > 0) { msg = c.msgProgressMore || c.msgProgress; pct = Math.floor((rem * 100) / group); }
    else { msg = c.msgProgress; pct = Math.floor((rem * 100) / group); }
    filled = rem === 0 && count > 0 ? group : rem;
    msg = msg.split('[buy]').join(buy).split('[get]').join(get).split('[remaining]').join(buy - rem).split('[free]').join(free).split('[in_cart]').join(count);

    document.querySelectorAll('.nova-bxgy').forEach(function (bar) {
      if (bar.closest('.nova-bundle.is-picking')) return; // popup shows the Bundle & Save progress instead
      bar.classList.toggle('is-unlocked', rem === 0 && count > 0);
      var cta = bar.classList.contains('nova-bxgy--cart') && bar.querySelector('.nova-bxgy__cta');
      if (cta) cta.hidden = free > 0;
      var m = bar.querySelector('.nova-bxgy__msg');
      if (m) m.textContent = msg;
      var f = bar.querySelector('.nova-bxgy__fill');
      if (f) f.style.width = pct + '%';
      bar.querySelectorAll('.nova-bxgy__step').forEach(function (s, i) { s.classList.toggle('is-done', i + 1 <= filled); });
    });
  }

  function cartSizeHint(cart) {
    for (var i = cart.items.length - 1; i >= 0; i--) {
      var opts = cart.items[i].options_with_values || [];
      for (var j = 0; j < opts.length; j++) {
        if (/\d{2}\s*mm/i.test(opts[j].value) && /size/i.test(opts[j].name)) return opts[j].value;
      }
    }
    return null;
  }

  // Only eligible items count (e.g. straps, not cases): the count comes from the server (sections/nova-bxgy-count.liquid)
  function refreshFromCart() {
    var sizeReq = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { window.novaCartSizeHint = cartSizeHint(cart); return cart; });
    var countReq = fetch(root + '?sections=nova-bxgy-count')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = new DOMParser().parseFromString(s['nova-bxgy-count'], 'text/html').getElementById('nova-bxgy-state');
        if (el) renderBars(parseInt(el.dataset.count, 10) || 0);
      });
    return Promise.all([sizeReq, countReq]).then(function (r) { return r[0]; });
  }
  window.novaRefreshBxgy = refreshFromCart;

  function innerOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshFromCart(); });
  }
  // back/forward cache can restore a page with an outdated bar
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshFromCart();
  });

  var dlg = document.getElementById('NovaBundle');
  var addedSomething = false;

  window.novaBundle = {
    afterAdd: function (res, opener) {
      addedSomething = true;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && res.sections) {
        var inner = innerOf(res.sections['cart-drawer'], '#CartDrawer');
        var target = document.getElementById('CartDrawer');
        if (inner && target) target.innerHTML = inner;
        drawer.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleInner = res.sections['cart-icon-bubble'] && innerOf(res.sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleInner) bubble.innerHTML = bubbleInner;
      }
      var card = opener && opener.closest('.nova-bundle-card');
      if (card && opener.hasAttribute('data-current-product') && current.template && current.template.dataset.againLabel) {
        opener.textContent = current.template.dataset.againLabel;
      }
      if (card) {
        var badge = card.querySelector('.nova-bundle-card__added');
        var n = card.querySelector('[data-count]');
        n.textContent = badge.hidden ? 1 : Number(n.textContent) + 1;
        badge.hidden = false;
        card.classList.add('is-added');
      }
      refreshFromCart().then(function () {
        var bar = dlg && dlg.querySelector('.nova-bundle__progress .nova-bxgy');
        if (dlg && dlg.open && !dlg.classList.contains('is-picking') && bar && bar.classList.contains('is-unlocked')) {
          window.novaBundle.showUpsell('cart');
        }
      });
    }
  };

  if (!dlg) return;
  var body = dlg.querySelector('[data-nova-bundle-body]');
  var loaded = false;

  // ---- optional "Complete your look" step once the offer is complete (Theme settings > Nova — Buy X Get Y)
  var upsell = dlg.querySelector('[data-nova-upsell]');
  var doneBtn = dlg.querySelector('[data-nova-bundle-done]');
  var upsellLoaded = false;
  var upsellState = null;

  function showUpsell(mode, offer) {
    if (!upsell || dlg.dataset.upsellStep !== 'true') return false;
    upsellState = { mode: mode, offer: offer || null };
    body.hidden = true;
    upsell.hidden = false;
    upsell.scrollTop = 0;
    dlg.classList.add('is-upsell');
    if (doneBtn) doneBtn.textContent = doneBtn.dataset.labelGo || doneBtn.textContent;
    if (!upsellLoaded) {
      upsellLoaded = true;
      var url = upsell.dataset.url;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=nova-upsell-products')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html').querySelector('.nova-bundle-page');
          upsell.querySelector('[data-nova-upsell-grid]').innerHTML = page ? page.innerHTML : '';
        })
        .catch(function () { upsellLoaded = false; });
    }
    return true;
  }
  function resetUpsell() {
    upsellState = null;
    if (upsell) upsell.hidden = true;
    body.hidden = false;
    dlg.classList.remove('is-upsell');
    if (doneBtn && doneBtn.dataset.label) doneBtn.textContent = doneBtn.dataset.label;
  }
  window.novaBundle.showUpsell = showUpsell;
  dlg.addEventListener('close', function () { setTimeout(resetUpsell, 0); });

  function loadPage(url, append) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=nova-bundle-products')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var page = doc.querySelector('.nova-bundle-page');
        if (!page) return;
        var grid = body.querySelector('.nova-bundle-grid');
        if (!append || !grid) {
          body.innerHTML = '<div class="nova-bundle__featured-slot"></div><div class="nova-bundle-grid"></div>';
          grid = body.querySelector('.nova-bundle-grid');
          placeFeatured();
        }
        Array.prototype.forEach.call(page.children, function (c) { grid.appendChild(c); });
        hideCurrentInGrid();
        var more = body.querySelector('.nova-bundle__more');
        if (more) more.remove();
        if (page.dataset.next) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nova-bundle__more';
          btn.textContent = 'Load more';
          btn.addEventListener('click', function () {
            btn.disabled = true;
            loadPage(page.dataset.next, true);
          });
          body.appendChild(btn);
        }
      });
  }

  // The product being viewed: featured first (alone, highlighted) unless it's already in the cart.
  // Always featured first, even when already in the cart (the shopper may want another color of it).
  var current = { id: null, template: null, qty: 0 };

  function placeFeatured() {
    var slot = body.querySelector('.nova-bundle__featured-slot');
    if (!slot) return;
    slot.innerHTML = '';
    if (!current.template) return;
    slot.appendChild(current.template.content.cloneNode(true));
    if (current.qty > 0) {
      var badge = slot.querySelector('.nova-bundle-card__added');
      badge.hidden = false;
      badge.querySelector('[data-count]').textContent = current.qty;
      slot.querySelector('.nova-bundle-card').classList.add('is-added');
      var btn = slot.querySelector('.nova-bundle-card__add');
      if (current.template.dataset.againLabel) btn.textContent = current.template.dataset.againLabel;
    }
  }

  function hideCurrentInGrid() {
    body.querySelectorAll('.nova-bundle-grid .nova-bundle-card').forEach(function (card) {
      card.hidden = current.id !== null && card.dataset.productId === current.id;
    });
  }

  function openBundle(opener) {
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    addedSomething = false;
    var bar = opener && opener.closest('.nova-bxgy');
    current.template = bar ? bar.querySelector('template[data-nova-bundle-current]') : null;
    current.id = current.template ? current.template.dataset.productId : null;
    current.qty = 0;
    placeFeatured();
    hideCurrentInGrid();
    dlg.showModal();
    refreshFromCart().then(function (cart) {
      if (!current.id || !cart) return;
      current.qty = cart.items.reduce(function (n, i) { return String(i.product_id) === current.id ? n + i.quantity : n; }, 0);
      if (current.qty > 0) placeFeatured();
    });
    if (!loaded) {
      loaded = true;
      loadPage(dlg.dataset.url, false).catch(function () { loaded = false; });
    }
  }

  function closeBundle(openCart) {
    dlg.close();
    var drawer = document.querySelector('cart-drawer');
    if (openCart || addedSomething) {
      if (drawer) drawer.open();
      else window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
    }
  }

  document.addEventListener('click', function (e) {
    var bundleOpener = e.target.closest('[data-nova-bundle-open]');
    if (bundleOpener && !bundleOpener.hasAttribute('data-pick-slot') && window.novaPick) window.novaPick = null;
    if (bundleOpener) {
      dlg.classList.toggle('is-picking', bundleOpener.hasAttribute('data-pick-slot'));
      // each picking session starts with clean "added" badges
      dlg.querySelectorAll('.nova-bundle-card.is-added').forEach(function (c) {
        c.classList.remove('is-added');
        var b = c.querySelector('.nova-bundle-card__added');
        if (b) b.hidden = true;
      });
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active')) drawer.close();
      openBundle(bundleOpener);
      return;
    }
    if (!dlg.open) return;
    if (e.target.closest('[data-nova-bundle-done]')) {
      if (upsellState && upsellState.mode === 'pick' && upsellState.offer) {
        var offer = upsellState.offer;
        doneBtn.setAttribute('aria-busy', 'true');
        Promise.resolve(offer.addBundle()).then(function () { dlg.close(); }).finally(function () { doneBtn.removeAttribute('aria-busy'); });
      } else {
        closeBundle(true);
      }
    }
    else if (e.target.closest('[data-nova-bundle-close]') || e.target === dlg) closeBundle(false);
  });
  dlg.addEventListener('close', function () {
    if (dlg.classList.contains('is-picking')) {
      dlg.classList.remove('is-picking');
      setTimeout(function () { window.novaPick = null; }, 0);
    }
  });
  dlg.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeBundle(false);
  });
})();

/* Nova — "I want only this one": add just the product being viewed, with the options chosen on the page. */
document.addEventListener('click', function (e) {
  var link = e.target.closest('[data-nova-add-single]');
  if (!link) return;
  e.preventDefault();
  var main = document.querySelector('product-info product-form [name="add"], product-form [name="add"]');
  if (main && !main.disabled) main.click();
  else if (main) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

/* Nova — "Complete your look" (cart + product page): clicking the image or name opens the quick-add popup instead of leaving the page. */
document.addEventListener('click', function (e) {
  var hit = e.target.closest('.nova-upsell__media, .nova-upsell__name, .nova-cross-sell__media, .nova-cross-sell__name');
  if (!hit) return;
  var card = hit.closest('.nova-upsell__card, .nova-cross-sell__item');
  var add = card && card.querySelector('[data-nova-quick-add]');
  if (!add) return;
  e.preventDefault();
  add.click();
});

/* Nova — "Bundle & Save" offer on the product page. */
if (!customElements.get('nova-bundle-offer')) {
  customElements.define(
    'nova-bundle-offer',
    class NovaBundleOffer extends HTMLElement {
      connectedCallback() {
        this.buy = Number(this.dataset.buy);
        this.get = Number(this.dataset.get);
        this.size = this.buy + this.get;
        this.picks = new Array(this.size - 1).fill(null);
        this.variants = JSON.parse(this.querySelector('[data-nova-variants]').textContent);
        this.form = document.getElementById(this.dataset.form);
        this.chooseLabel(); // read the button label before the slots get re-rendered

        this.addEventListener('change', (e) => {
          if (e.target.name && e.target.name.indexOf('nova-bo-') === 0) this.setMode(e.target.value);
        });
        this.querySelector('[data-mode="bundle"]').addEventListener('click', (e) => {
          if (!e.target.closest('input, [data-pick-slot], .nova-bo__remove')) this.setMode('bundle');
        });
        this.addEventListener('click', (e) => {
          const slotBtn = e.target.closest('[data-pick-slot]');
          if (slotBtn) this.startPick(Number(slotBtn.dataset.pickSlot));
          const rm = e.target.closest('.nova-bo__remove');
          if (rm && rm.hasAttribute('data-cart-remove')) {
            e.preventDefault();
            const s = Number(rm.dataset.cartRemove);
            const id = s === 0 ? this.current().id : this.picks[s - 1] && this.picks[s - 1].id;
            if (id) this.removeFromCart(id, rm);
          } else if (rm) { e.preventDefault(); this.picks[Number(rm.dataset.slot) - 1] = null; this.renderSlot(Number(rm.dataset.slot)); this.update(); this.savePending(); }
        }, true);

        // the page's variant pickers change the first slot + prices
        const info = this.closest('product-info') || document;
        info.addEventListener('change', (e) => {
          if (e.target.name && e.target.name.indexOf('nova-bo-') === 0) return;
          setTimeout(() => this.syncCart(), 80);
        });

        // "Add to cart" adds the whole bundle when the bundle option is selected
        this.onSubmit = (e) => {
          if (e.target !== this.form || this.mode !== 'bundle') return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addBundle();
        };
        document.addEventListener('submit', this.onSubmit, true);

        this.setMode(this.querySelector('input[value="bundle"]').checked ? 'bundle' : 'single');

        // the widget is NOT synced with the cart: every visit starts a fresh bundle (this strap + empty slots)
        this.storeKey = 'novaBundle:' + (this.closest('product-info') ? this.closest('product-info').dataset.url : location.pathname);
        try { localStorage.removeItem(this.storeKey); } catch (e) {}
        this.syncCart();
      }

      // "×" on a strap already in the cart: take one unit of it out of the cart
      removeFromCart(variantId, btn) {
        if (btn) btn.disabled = true;
        const drawer = document.querySelector('cart-drawer');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const line = cart.items.find((i) => String(i.variant_id) === String(variantId));
            if (!line) return null;
            const body = { id: line.key, quantity: line.quantity - 1 };
            if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            }).then((r) => r.json());
          })
          .then((res) => {
            if (res && res.sections && drawer) {
              // refresh the drawer without opening it
              ['cart-drawer', 'cart-icon-bubble'].forEach((id) => {
                const html = res.sections[id];
                if (!html) return;
                const doc = new DOMParser().parseFromString(html, 'text/html');
                if (id === 'cart-drawer') {
                  const src = doc.querySelector('.drawer__inner'), dst = document.querySelector('cart-drawer .drawer__inner');
                  if (src && dst) dst.innerHTML = src.innerHTML;
                  drawer.classList.toggle('is-empty', res.item_count === 0);
                } else {
                  const src = doc.querySelector('.shopify-section'), dst = document.getElementById('cart-icon-bubble');
                  if (src && dst) dst.innerHTML = src.innerHTML;
                }
              });
            }
            if (window.novaRefreshBxgy) window.novaRefreshBxgy();
            return this.syncCart();
          })
          .catch(() => { if (btn) btn.disabled = false; });
      }

      savePending() {} // picks are not kept between visits

      // re-render the slots from the shopper's picks only (no cart lookup)
      syncCart() {
        this.currentInCart = false;
        this.picks = this.picks.map((p) => (p && !p.inCart ? p : null));
        for (let i = 1; i < this.size; i++) this.renderSlot(i);
        const rm0 = this.querySelector('[data-slot="0"] [data-cart-remove]');
        if (rm0) rm0.hidden = true;
        this.update();
        return Promise.resolve();
      }

      disconnectedCallback() { document.removeEventListener('submit', this.onSubmit, true); }

      money(cents) {
        const fmt = this.dataset.moneyFormat || '${{amount}}';
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
          const v = cents / 100;
          if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
          if (k.indexOf('comma') > -1) return v.toFixed(2).replace('.', ',');
          return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        });
      }

      current() {
        const id = this.form && this.form.querySelector('[name="id"]') && this.form.querySelector('[name="id"]').value;
        return this.variants.find((v) => String(v.id) === String(id)) || this.variants[0];
      }

      setMode(mode) {
        this.mode = mode;
        this.querySelectorAll('.nova-bo__opt').forEach((o) => o.classList.toggle('is-active', o.dataset.mode === mode));
        const r = this.querySelector('input[value="' + mode + '"]');
        if (r) r.checked = true;
        this.update();
      }

      startPick(slot) {
        window.novaPick = (res) => {
          const v = res.variant, p = res.product;
          this.picks[slot - 1] = { id: v.id, price: v.price_cents, compare: v.compare_cents, title: p.title, variant: v.title, image: v.image || p.image };
          this.savePending();
          this.setMode('bundle');
          this.renderSlot(slot);
          this.update();
          const dlg = document.getElementById('NovaBundle');
          const next = this.picks.findIndex((x) => !x);
          if (next > -1 && dlg && dlg.open && dlg.dataset.closeEachPick === 'true') {
            // test mode: close the popup after every pick, the shopper continues from the widget
            this.syncPopup(dlg);
            dlg.close();
            const w = this.querySelector('[data-mode="bundle"]');
            // after the dialog has restored the page scroll, bring the widget back into view
            if (w) setTimeout(() => {
              const top = w.getBoundingClientRect().top + window.scrollY - (window.innerHeight - w.offsetHeight) / 2;
              window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
            }, 450);
          } else if (next > -1 && dlg && dlg.open) {
            // keep the popup open until the bundle is complete
            this.startPick(next + 1);
            this.syncPopup(dlg);
          } else if (dlg && dlg.open) {
            this.syncPopup(dlg);
            const shown = window.novaBundle && window.novaBundle.showUpsell && window.novaBundle.showUpsell('pick', this);
            if (!shown) {
              // bundle complete: add it and go straight to the cart (no stop on the product page)
              setTimeout(() => {
                Promise.resolve(this.addBundle()).then(() => { if (dlg.open) dlg.close(); });
              }, 500);
            }
          }
        };
        const dlg = document.getElementById('NovaBundle');
        if (dlg) setTimeout(() => this.syncPopup(dlg), 0);
      }

      // while filling slots, the popup header shows the bundle progress (not the cart's)
      syncPopup(dlg) {
        const filled = 1 + this.picks.filter(Boolean).length;
        const msg = dlg.querySelector('.nova-bundle__progress .nova-bxgy__msg');
        const fill = dlg.querySelector('.nova-bundle__progress .nova-bxgy__fill');
        const bar = dlg.querySelector('.nova-bundle__progress .nova-bxgy');
        if (msg) msg.textContent = this.querySelector('[data-msg]').textContent;
        if (fill) fill.style.width = Math.round((filled * 100) / this.size) + '%';
        if (bar) {
          bar.classList.toggle('is-unlocked', filled >= this.size);
          bar.querySelectorAll('.nova-bxgy__step').forEach((s, i) => s.classList.toggle('is-done', i < filled));
        }
      }

      renderSlot(slot) {
        const li = this.querySelector('[data-slot="' + slot + '"]');
        const pick = this.picks[slot - 1];
        const isFree = slot === this.size - 1 && this.get > 0;
        if (!pick) {
          li.classList.remove('is-filled');
          li.innerHTML = '<button type="button" class="nova-bo__pick" data-nova-bundle-open data-pick-slot="' + slot + '">' +
            '<span class="nova-bo__plus" aria-hidden="true">+</span><span class="nova-bo__choose">' + this.chooseLabel() + '</span>' +
            (isFree ? '<span class="nova-bo__free">FREE</span>' : '') + '</button>';
          return;
        }
        li.classList.add('is-filled');
        const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const head = '<span class="nova-bo__thumb"><img src="' + esc((pick.image || '').replace(/width=\d+/, 'width=160')) + '" alt="" width="56" height="56"></span>' +
          '<span class="nova-bo__info"><span class="nova-bo__name">' + esc(pick.title) + '</span><span class="nova-bo__variant">' + esc(pick.variant) + '</span></span>';
        const price = '<span class="nova-bo__amount">' + this.money(pick.price).replace(/\s*[A-Z]{3}$/, '') + '</span>';
        if (pick.inCart) {
          li.innerHTML = head + '<span class="nova-bo__side">' + price + '<span class="nova-bo__actions">' +
            '<span class="nova-bo__tag is-in-cart">✓ In cart</span>' +
            '<button type="button" class="nova-bo__remove" data-cart-remove="' + slot + '" aria-label="Remove from cart">×</button></span></span>';
          return;
        }
        li.innerHTML = head + '<span class="nova-bo__side">' + price + '<span class="nova-bo__actions">' +
          '<button type="button" class="nova-bo__change" data-nova-bundle-open data-pick-slot="' + slot + '">Change</button>' +
          '<button type="button" class="nova-bo__remove" data-slot="' + slot + '" aria-label="Remove">×</button></span></span>';
      }

      chooseLabel() {
        if (!this._choose) {
          const c = this.querySelector('.nova-bo__choose');
          this._choose = c ? c.textContent : 'Choose';
        }
        return this._choose;
      }

      update() {
        const cur = this.current();
        // slot 0 = this strap with the variant selected on the page
        const img = this.querySelector('[data-current-img]');
        if (img && cur.image) img.src = cur.image;
        const vt = this.querySelector('[data-current-variant]');
        if (vt) vt.textContent = cur.title;
        const cp = this.querySelector('[data-current-price]');
        if (cp) cp.textContent = this.money(cur.price).replace(/\s*[A-Z]{3}$/, '');

        const sp = this.querySelector('[data-single-price]'), sc = this.querySelector('[data-single-compare]');
        sp.textContent = this.money(cur.price);
        sc.hidden = !(cur.compare > cur.price);
        if (cur.compare > cur.price) sc.textContent = this.money(cur.compare);

        // bundle total = this strap + the straps picked so far; once the bundle is complete the cheapest one(s) are free
        const items = [cur].concat(this.picks.filter(Boolean));
        const prices = items.map((i) => i.price).sort((a, b) => a - b);
        const freeTotal = items.length >= this.size ? prices.slice(0, this.get).reduce((a, b) => a + b, 0) : 0;
        const total = prices.reduce((a, b) => a + b, 0) - freeTotal;
        const compare = items.reduce((a, i) => a + Math.max(i.compare || 0, i.price), 0);
        this.querySelector('[data-bundle-price]').textContent = this.money(total);
        const cmp = this.querySelector('[data-bundle-compare]');
        cmp.hidden = !(compare > total);
        cmp.textContent = this.money(compare);

        // once the bundle is complete, show which strap is free: its price struck through + FREE
        const short = (c) => this.money(c).replace(/\s*[A-Z]{3}$/, '');
        const bySlot = [{ slot: 0, price: cur.price }].concat(this.picks.map((p, i) => (p ? { slot: i + 1, price: p.price } : null)).filter(Boolean));
        const freeSlots = items.length >= this.size
          ? bySlot.slice().sort((a, b) => a.price - b.price || b.slot - a.slot).slice(0, this.get).map((x) => x.slot)
          : [];
        bySlot.forEach((x) => {
          const el = x.slot === 0 ? this.querySelector('[data-current-price]') : this.querySelector('[data-slot="' + x.slot + '"] .nova-bo__amount');
          if (!el) return;
          const isFree = freeSlots.indexOf(x.slot) > -1;
          el.classList.toggle('is-free', isFree);
          el.innerHTML = isFree ? '<s>' + short(x.price) + '</s> <span class="nova-bo__free-price">FREE</span>' : short(x.price);
        });

        // progress inside the widget
        const filled = 1 + this.picks.filter(Boolean).length;
        const remaining = this.size - filled;
        let msg;
        if (remaining <= 0) msg = this.dataset.msgDone;
        else if (remaining === 1 && this.get > 0) msg = this.dataset.msgNext;
        else msg = (this.dataset.msgStart || '').split('[remaining]').join(remaining);
        this.querySelector('[data-msg]').textContent = msg;
        this.querySelector('[data-fill]').style.width = Math.round((filled * 100) / this.size) + '%';
        this.classList.toggle('is-complete', remaining <= 0);
      }

      addBundle() {
        const firstEmpty = this.picks.findIndex((p) => !p);
        if (firstEmpty > -1) {
          // bundle not complete: open the picker for the next empty slot
          const btn = this.querySelector('[data-pick-slot="' + (firstEmpty + 1) + '"]');
          if (btn) btn.click();
          return;
        }
        const submit = this.form.querySelector('[name="add"]');
        if (submit) submit.setAttribute('aria-busy', 'true');
        const drawer = document.querySelector('cart-drawer');
        const toAdd = (this.currentInCart ? [] : [this.current()]).concat(this.picks.filter((p) => p && !p.inCart));
        if (!toAdd.length) {
          // everything is already in the cart: just show it
          if (drawer) drawer.open(); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          if (submit) submit.removeAttribute('aria-busy');
          return Promise.resolve();
        }
        const items = toAdd.map((p) => ({ id: Number(p.id), quantity: 1 }));
        const body = { items: items };
        if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
        return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status && res.description) { alert(res.description); return; }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nova-bundle-offer', cartData: res });
            // the picks stay until the page is refreshed or left
            if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
            else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          })
          .finally(() => { if (submit) submit.removeAttribute('aria-busy'); });
      }
    }
  );
}

/* Nova — bundle popup cards: choose size & color inline, add without a second popup. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function data(card) {
    if (!card._nova) card._nova = JSON.parse(card.querySelector('[data-variants]').textContent);
    return card._nova;
  }
  function selected(card) {
    var sel = [];
    card.querySelectorAll('[data-opt]').forEach(function (el) {
      var i = Number(el.dataset.opt);
      if (el.tagName === 'SELECT') sel[i] = el.value;
      else if (el.classList.contains('is-active')) sel[i] = el.dataset.val;
    });
    return sel;
  }
  function variantFor(card, sel) {
    var d = data(card);
    return d.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; }); });
  }
  function refresh(card) {
    var v = variantFor(card, selected(card));
    var price = card.querySelector('[data-price]');
    var btn = card.querySelector('[data-nova-inline-add]');
    if (v) {
      price.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      var img = card.querySelector('.nova-bundle-card__media img');
      if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
    }
    btn.disabled = !v || !v.available;
    btn.textContent = !v ? 'Unavailable' : v.available ? '+ Add' : 'Sold out';
    return v;
  }
  // pick an available combination that keeps the option the shopper just changed
  function settle(card, changedIndex) {
    var sel = selected(card);
    var v = variantFor(card, sel);
    if (v && v.available) return;
    var alt = data(card).variants.find(function (x) { return x.available && x.options[changedIndex] === sel[changedIndex]; });
    if (!alt) return;
    card.querySelectorAll('[data-opt]').forEach(function (el) {
      var i = Number(el.dataset.opt);
      if (i === changedIndex) return;
      if (el.tagName === 'SELECT') el.value = alt.options[i];
      else el.classList.toggle('is-active', el.dataset.val === alt.options[i]);
    });
  }

  // pre-select the watch size the shopper already has (page or cart), then sync each new card
  function initCards(scope) {
    var hint = (window.novaSizeFromPage && window.novaSizeFromPage()) || window.novaCartSizeHint;
    scope.querySelectorAll('.nova-bundle-card:not([data-ready])').forEach(function (card) {
      if (!card.querySelector('[data-variants]')) return;
      card.setAttribute('data-ready', '');
      if (hint && window.novaPickByHint) {
        card.querySelectorAll('select[data-opt]').forEach(function (s) {
          var m = window.novaPickByHint([].map.call(s.options, function (o) { return o.value; }), hint);
          if (m) s.value = m;
        });
      }
      var firstSelect = card.querySelector('select[data-opt]');
      settle(card, firstSelect ? Number(firstSelect.dataset.opt) : 0);
      refresh(card);
    });
  }
  new MutationObserver(function () {
    var pop = document.getElementById('NovaBundle');
    if (pop) initCards(pop);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('.nova-bundle-card__select');
    if (!s) return;
    var card = s.closest('.nova-bundle-card');
    settle(card, Number(s.dataset.opt));
    refresh(card);
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.nova-bundle-card__color');
    if (sw) {
      var card = sw.closest('.nova-bundle-card');
      card.querySelectorAll('.nova-bundle-card__color[data-opt="' + sw.dataset.opt + '"]').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      settle(card, Number(sw.dataset.opt));
      refresh(card);
      return;
    }
    var btn = e.target.closest('[data-nova-inline-add]');
    if (!btn) return;
    var c = btn.closest('.nova-bundle-card');
    var v = refresh(c);
    if (!v || !v.available) return;
    var d = data(c);

    if (typeof window.novaPick === 'function') {
      // filling a Bundle & Save slot (the popup stays open until the bundle is complete)
      var pick = window.novaPick;
      window.novaPick = null;
      var badge = c.querySelector('.nova-bundle-card__added');
      if (badge) {
        var n = badge.querySelector('[data-count]');
        n.textContent = badge.hidden ? 1 : Number(n.textContent) + 1;
        badge.hidden = false;
      }
      c.classList.add('is-added');
      btn.textContent = '✓ Added';
      setTimeout(function () { refresh(c); }, 1200);
      pick({ variant: v, product: { title: d.title, image: d.image } });
      return;
    }

    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    fetch(((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { btn.textContent = res.description; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nova-bundle-card', cartData: res });
        if (window.novaBundle) window.novaBundle.afterAdd(res, btn);
        btn.textContent = '✓ Added';
        setTimeout(function () { refresh(c); }, 1400);
      })
      .finally(function () { btn.disabled = false; });
  });
})();

/* Nova — welcome popup (newsletter + first-order code). */
(function () {
  'use strict';
  var dlg = document.getElementById('NovaWelcome');
  if (!dlg) return;
  var KEY = 'novaWelcome';
  var code = dlg.dataset.code;
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  function busy() {
    var drawer = document.querySelector('cart-drawer');
    return !!document.querySelector('dialog[open]') || (drawer && drawer.classList.contains('active'));
  }
  function open(force) {
    if (dlg.open) return;
    if (!force && busy()) { setTimeout(function () { open(false); }, 4000); return; }
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    dlg.showModal();
  }
  function close() {
    if (!state.subscribed) { state.dismissedAt = Date.now(); save(); }
    dlg.close();
  }

  var params = new URLSearchParams(location.search);
  var posted = params.get('customer_posted') === 'true' && location.hash === '#NovaWelcomeForm';
  var success = !!dlg.querySelector('[data-nova-welcome-success]');

  if (posted && success) {
    // signed up: remember it, pre-apply the code to the cart session, show the code
    state.subscribed = true; save();
    if (code) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    history.replaceState(null, '', location.pathname);
    open(true);
  } else if (location.hash === '#NovaWelcomeForm' && dlg.querySelector('.nova-welcome__error')) {
    open(true); // invalid email: show the error
  } else if (dlg.hasAttribute('data-preview')) {
    setTimeout(function () { open(true); }, 400); // theme editor preview
  } else if (!state.subscribed) {
    var days = Number(dlg.dataset.days || 7);
    var recentlyClosed = state.dismissedAt && Date.now() - state.dismissedAt < days * 864e5;
    if (!recentlyClosed) {
      // product pages (ad landing pages): no timer unless enabled — only the exit intent below
      var timerOk = dlg.dataset.page !== 'product' || dlg.dataset.pdp === 'true';
      if (timerOk) setTimeout(function () { open(false); }, Number(dlg.dataset.delay || 20) * 1000);
      if (dlg.dataset.exit === 'true' && window.matchMedia('(min-width: 750px)').matches) {
        document.addEventListener('mouseout', function onOut(e) {
          if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(false); }
        });
      }
    }
  }

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-nova-welcome-close]')) {
      if (e.target.closest('a[data-nova-welcome-close]')) { dlg.close(); return; } // success link: let it navigate
      e.preventDefault();
      close();
      return;
    }
    var copy = e.target.closest('[data-nova-welcome-copy]');
    if (copy && code) {
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(function () {}).finally(function () {
        var small = copy.querySelector('small');
        if (small) small.textContent = copy.dataset.copied || 'Copied';
      });
    }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
})();

/* ================= Cart drawer — "Complete your look" cards (one dropdown per option + "+ Add") ================= */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function variantsOf(card) {
    if (!card._nbagVariants) {
      var el = card.querySelector('script[data-nbag-variants]');
      try { card._nbagVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { card._nbagVariants = []; }
    }
    return card._nbagVariants;
  }

  function sync(card) {
    var selects = card.querySelectorAll('select[data-nbag-opt]');
    if (!selects.length) return;
    var chosen = [].map.call(selects, function (s) { return s.value; });
    var v = variantsOf(card).filter(function (x) {
      return chosen.every(function (val, i) { return x.options[i] === val; });
    })[0];
    var btn = card.querySelector('[data-nbag-add]');
    var price = card.querySelector('[data-nbag-price]');
    if (!btn) return;
    if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
    if (v && v.available) {
      btn.setAttribute('data-variant-id', v.id);
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-label');
    } else {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    }
    if (v && price) price.textContent = v.price;
    // show the photo of the chosen variant
    var img = card.querySelector('.nbag-up__media img');
    if (v && v.image && img && img.getAttribute('src') !== v.image) {
      // keep the current photo until the new one is loaded (no blank flash)
      var next = new Image();
      next.onload = function () {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.loading = 'eager';
        img.src = v.image;
      };
      next.src = v.image;
    }
  }

  // pre-select the watch size of the strap already in the cart
  function presetSizes(scope) {
    if (!window.novaPickByHint) return;
    (scope || document).querySelectorAll('select[data-nbag-opt][data-size-hint]:not([data-preset])').forEach(function (s) {
      s.setAttribute('data-preset', '');
      var m = window.novaPickByHint([].map.call(s.options, function (o) { return o.value; }), s.getAttribute('data-size-hint'));
      if (m) {
        s.value = m;
        var card = s.closest('[data-nbag-card]');
        if (card) sync(card);
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('select[data-nbag-opt]')) {
      var card = e.target.closest('[data-nbag-card]');
      if (card) sync(card);
    }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nbag-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (drawer && res.sections) drawer.renderContents(res);
        if (window.novaRefreshBxgy) window.novaRefreshBxgy();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = (err && err.message) || 'Error';
      });
  });

  var target = document.getElementById('CartDrawer');
  presetSizes(target || document);
  if (target && window.MutationObserver) {
    new MutationObserver(function () { presetSizes(target); }).observe(target, { childList: true, subtree: true });
  }
})();
